import type { App } from '@vue/runtime-core';
import { useAppStore } from '@/stores/app';

/**
 * Plugin d'initialisation de l'application
 * Rafraîchit automatiquement les données utilisateur au démarrage et lors du retour sur l'onglet
 */
export default {
  install(app: App) {
    let lastRefresh = Date.now();
    const MIN_REFRESH_INTERVAL = 30000; // 30 secondes minimum entre 2 rafraîchissements

    const refreshIfNeeded = async () => {
      const now = Date.now();
      if (now - lastRefresh < MIN_REFRESH_INTERVAL) {
        return; // Éviter les rafraîchissements trop fréquents
      }

      const appStore = useAppStore();
      if (appStore.isAuthenticated) {
        try {
          await appStore.refreshUserData();
          lastRefresh = now;
        } catch (error) {
          console.error('Erreur lors du rafraîchissement:', error);
        }
      }
    };

    // Attendre que l'app soit montée
    app.mixin({
      async mounted() {
        // S'exécuter seulement pour le composant racine
        if (this.$root === this) {
          // Rafraîchir au démarrage
          await refreshIfNeeded();

          // Rafraîchir quand l'utilisateur revient sur l'onglet
          document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
              void refreshIfNeeded();
            }
          });

          // Rafraîchir quand la fenêtre reprend le focus
          window.addEventListener('focus', () => {
            void refreshIfNeeded();
          });

          if (import.meta.env.DEV) {
            console.log('🚀 Plugin d\'initialisation chargé - Auto-refresh activé');
          }
        }
      },
    });
  },
};
